/**
 * Strategify-Logo: Mark + Wordmark.
 *
 * Mark = stilisiertes „S" mit zwei sich kreuzenden Bögen, die einen weichen
 * 5-Schichten-Eindruck erzeugen (eine Andeutung der fünf Workshop-Module).
 * Pure SVG mit `currentColor` — funktioniert in Light- und Dark-Mode ohne
 * separates Asset.
 *
 * Wordmark = „strategify" in Geist (Display-Sans), modern und kantig
 * — passt zum „Premium-Tech-Tool"-Vibe der App. Tighter Tracking
 * macht die Wortmarke selbst bei kleinen Größen markant.
 */
import { cn } from "@/lib/utils";

interface LogoProps {
  /** Stellt nur die Mark dar, ohne Wordmark (z.B. Favicon-Größe). */
  iconOnly?: boolean;
  /** Größen-Variante in `em`. Default: 1.5em (Header-tauglich). */
  size?: number;
  className?: string;
  /** ARIA-Label, falls iconOnly. */
  label?: string;
}

export function Logo({
  iconOnly = false,
  size = 1.5,
  className,
  label = "Strategify",
}: LogoProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-2 text-primary", className)}
      style={{ fontSize: `${size}em` }}
      aria-label={iconOnly ? label : undefined}
    >
      <LogoMark />
      {!iconOnly && (
        <span className="font-display text-[1em] font-semibold leading-none tracking-tight text-foreground">
          strategify
        </span>
      )}
    </span>
  );
}

function LogoMark() {
  // 24×24 Viewbox, currentColor = primary.
  // Drei konzentrische, leicht versetzte Bögen — abstrahierter „S"-Flow, der
  // sich von oben links nach unten rechts bewegt. Subtil aber merkbar.
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      width="1.25em"
      height="1.25em"
      aria-hidden="true"
    >
      <path d="M 17.5 5.5 C 17.5 3.5, 15 2.5, 12 2.5 C 8 2.5, 6 4.5, 6 7.5 C 6 10.5, 9 11, 12 12 C 15 13, 18 13.5, 18 16.5 C 18 19.5, 16 21.5, 12 21.5 C 9 21.5, 6.5 20.5, 6.5 18.5" />
      <circle cx="20" cy="6" r="1.4" fill="currentColor" stroke="none" opacity="0.6" />
    </svg>
  );
}
